import { RefObject, useEffect, useState } from "react"

export interface Dimensions {
  width: number
  height: number
}

export const useResizeObserver = (ref: RefObject<HTMLElement>) => {
  const [dimensions, setDimensions] = useState<Dimensions>({ width: 0, height: 0 })

  useEffect(
    function setupObserver() {
      const observeTarget = ref.current

      if (!observeTarget) {
        return
      }

      setTimeout(() => {
        setDimensions({ width: observeTarget.clientWidth, height: observeTarget.clientHeight })
      }, 100)

      const resizeObserver = new ResizeObserver((entries) => {
        entries.forEach((entry) => {
          setDimensions({
            width: entry.contentRect.width,
            height: entry.contentRect.height,
          })
        })
      })

      if (observeTarget) {
        resizeObserver.observe(observeTarget)
      }

      if (!resizeObserver) return

      return () => {
        if (observeTarget) {
          resizeObserver.unobserve(observeTarget)
        }
      }
    },
    [ref]
  )

  return dimensions
}
